<template>
  <div class="view">
    <el-dialog :visible.sync="isShowGratitude" width="30%" center class="">
      <div class="w-full">
        <div class="relative">
          <img :src="imgLink" alt="gratitude" class="h-auto w-full" />
          <div
            class="absolute top-2 right-2 w-6 h-6 flex justify-center items-center bg-primary rounded-full"
          >
            <feather-icon
              icon="XIcon"
              @click="isShowGratitude = false"
              class="cursor-pointer text-white"
              svgClasses="w-6 p-1"
            ></feather-icon>
          </div>
        </div>
        <div class="">
          <div
            class="w-full flex gap-4 bg-white py-4 px-6 bottom-b-1px"
            v-for="(item, index) in getDonors.result"
          >
            <img
              v-if="item.image == 'null' || listType == 'individual'"
              :src="imgLink"
              alt=""
              class="profileimg"
            />
            <img
              v-else
              :src="$imageURL + '/' + item.image"
              alt=""
              class="profileimg"
            />
            <p class="fsize16 sm-fsize14 clr-7d7d7d font-medium">
              {{ index + 1 + "-" + item.name }}
            </p>
          </div>
        </div>
      </div>
    </el-dialog>
    <h2 class="text-center fsize36 sm-fsize20 text-primary font-semibold">
      Gratitude
    </h2>
    <p class="lg:px-40 fsize20 sm-fsize14">
      A heartfelt thank you to all our incredible donors! Your generosity and
      support have made a meaningful impact. Your belief in our cause fuels our
      mission and brings hope to those we serve.
    </p>
    <div class="m-auto pt-8 lg:px-12 md:px-0">
      <el-tabs class="gratitudetab" v-model="activeName">
        <!-- @tab-click="handleClick" -->
        <el-tab-pane
          label="Individuals"
          name="first"
          class="lg:pt-10 md:pt-8 pt-5"
        >
          <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8">
            <div>
              <img
                :src="compassionSupport"
                alt="img"
                class="custgratitudeimg"
              />
              <div class="custbordergr mt-5">
                <div
                  class="flex gap-2 items-center p-2 borderbott"
                  v-for="item in getDonorType.individual[
                    'Compassion Supporter'
                  ].slice(0, 2)"
                  :key="item._id"
                >
                  <img :src="compassionSupport" alt="" class="profileimg" />
                  <p class="fsize18">{{ item.name }}</p>
                </div>
                <div class="relative">
                  <div
                    class="flex gap-2 items-center p-2"
                    v-for="item in getDonorType.individual[
                      'Compassion Supporter'
                    ].slice(2, 3)"
                    :key="item._id"
                  >
                    <img :src="compassionSupport" alt="" class="profileimg" />
                    <p class="fsize18">{{ item.name }}i</p>
                  </div>
                  <div class="absolute bottom-0 right-0">
                    <div
                      @click="
                        showDonorList(
                          'individual',
                          'Compassion Supporter',
                          compassionSupport
                        )
                      "
                      class="cursor-pointer flex gap-2 items-center bg-primary custborderall p-2"
                    >
                      <p class="text-white fsize14">View All</p>
                      <feather-icon
                        icon="ArrowRightIcon"
                        svgClasses="w-4 h-4"
                        class="text-white"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                :src="caregiverChampion"
                alt="img"
                class="custgratitudeimg"
              />
              <div class="custbordergr mt-5">
                <div
                  class="flex gap-2 items-center p-2 borderbott"
                  v-for="item in getDonorType.individual[
                    'Caregiver Champion'
                  ].slice(0, 2)"
                  :key="item._id"
                >
                  <img :src="caregiverChampion" alt="" class="profileimg" />
                  <p class="fsize18">{{ item.name }}</p>
                </div>
                <div class="relative">
                  <div
                    class="flex gap-2 items-center p-2"
                    v-for="item in getDonorType.individual[
                      'Caregiver Champion'
                    ].slice(2, 3)"
                    :key="item._id"
                  >
                    <img :src="caregiverChampion" alt="" class="profileimg" />
                    <p class="fsize18">{{ item.name }}</p>
                  </div>
                  <div class="absolute bottom-0 right-0">
                    <div
                      @click="
                        showDonorList(
                          'individual',
                          'Caregiver Champion',
                          caregiverChampion
                        )
                      "
                      class="cursor-pointer flex gap-2 items-center bg-primary custborderall p-2"
                    >
                      <p class="text-white fsize14">View All</p>
                      <feather-icon
                        icon="ArrowRightIcon"
                        svgClasses="w-4 h-4"
                        class="text-white"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img :src="angelOfCare" alt="img" class="custgratitudeimg" />
              <div class="custbordergr mt-5">
                <div
                  class="flex gap-2 items-center p-2 borderbott"
                  v-for="item in getDonorType.individual['Angel of Care'].slice(
                    0,
                    2
                  )"
                  :key="item._id"
                >
                  <img :src="angelOfCare" alt="" class="profileimg" />
                  <p class="fsize18">{{ item.name }}</p>
                </div>
                <div class="relative">
                  <div
                    class="flex gap-2 items-center p-2"
                    v-for="item in getDonorType.individual[
                      'Angel of Care'
                    ].slice(2, 3)"
                    :key="item._id"
                  >
                    <img :src="angelOfCare" alt="" class="profileimg" />
                    <p class="fsize18">{{ item.name }}</p>
                  </div>
                  <div class="absolute bottom-0 right-0">
                    <div
                      @click="
                        showDonorList(
                          'individual',
                          'Angel of Care',
                          angelOfCare
                        )
                      "
                      class="cursor-pointer flex gap-2 items-center bg-primary custborderall p-2"
                    >
                      <p class="text-white fsize14">View All</p>
                      <feather-icon
                        icon="ArrowRightIcon"
                        svgClasses="w-4 h-4"
                        class="text-white"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="Corporate"
          name="second"
          class="lg:pt-10 md:pt-8 pt-5"
        >
          <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8">
            <div>
              <img
                :src="caregiverCompassion"
                alt="img"
                class="custgratitudeimg"
              />
              <div class="custbordergr mt-5">
                <div
                  class="flex gap-2 items-center p-2 borderbott"
                  v-for="item in getDonorType.corporate[
                    'Corporate Compassion Partner'
                  ].slice(0, 2)"
                  :key="item._id"
                >
                  <img
                    v-if="item.image == 'null'"
                    :src="caregiverCompassion"
                    alt=""
                    class="profileimg"
                  />
                  <img
                    v-else
                    :src="$imageURL + '/' + item.image"
                    alt=""
                    class="profileimg"
                  />
                  <p class="fsize18">{{ item.name }}</p>
                </div>
                <div class="relative">
                  <div
                    class="flex gap-2 items-center p-2"
                    v-for="item in getDonorType.corporate[
                      'Corporate Compassion Partner'
                    ].slice(2, 3)"
                    :key="item._id"
                  >
                    <img
                      v-if="item.image == 'null'"
                      :src="caregiverCompassion"
                      alt=""
                      class="profileimg"
                    />
                    <img
                      v-else
                      :src="$imageURL + '/' + item.image"
                      alt=""
                      class="profileimg"
                    />
                    <p class="fsize18">{{ item.name }}</p>
                  </div>
                  <div class="absolute bottom-0 right-0">
                    <div
                      @click="
                        showDonorList(
                          'corporate',
                          'Corporate Compassion Partner',
                          caregiverCompassion
                        )
                      "
                      class="cursor-pointer flex gap-2 items-center bg-primary custborderall p-2"
                    >
                      <p class="text-white fsize14">View All</p>
                      <feather-icon
                        icon="ArrowRightIcon"
                        svgClasses="w-4 h-4"
                        class="text-white"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                :src="caregiverAdvocate"
                alt="img"
                class="custgratitudeimg"
              />
              <div class="custbordergr mt-5">
                <div
                  class="flex gap-2 items-center p-2 borderbott"
                  v-for="item in getDonorType.corporate[
                    'CSR Caregiver Advocate'
                  ].slice(0, 2)"
                  :key="item._id"
                >
                  <img
                    v-if="item.image == 'null'"
                    :src="caregiverAdvocate"
                    alt=""
                    class="profileimg"
                  />
                  <img
                    v-else
                    :src="$imageURL + '/' + item.image"
                    alt=""
                    class="profileimg"
                  />
                  <p class="fsize18">{{ item.name }}</p>
                </div>
                <div class="relative">
                  <div
                    class="flex gap-2 items-center p-2"
                    v-for="item in getDonorType.corporate[
                      'CSR Caregiver Advocate'
                    ].slice(2, 3)"
                    :key="item._id"
                  >
                    <img
                      v-if="item.image == 'null'"
                      :src="caregiverAdvocate"
                      alt=""
                      class="profileimg"
                    />
                    <img
                      v-else
                      :src="$imageURL + '/' + item.image"
                      alt=""
                      class="profileimg"
                    />
                    <p class="fsize18">{{ item.name }}</p>
                  </div>
                  <div class="absolute bottom-0 right-0">
                    <div
                      @click="
                        showDonorList(
                          'corporate',
                          'CSR Caregiver Advocate',
                          caregiverAdvocate
                        )
                      "
                      class="cursor-pointer flex gap-2 items-center bg-primary custborderall p-2"
                    >
                      <p class="text-white fsize14">View All</p>
                      <feather-icon
                        icon="ArrowRightIcon"
                        svgClasses="w-4 h-4"
                        class="text-white"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img :src="caregiverPartner" alt="img" class="custgratitudeimg" />
              <div class="custbordergr mt-5">
                <div
                  class="flex gap-2 items-center p-2 borderbott"
                  v-for="item in getDonorType.corporate[
                    `Caregiver's Champion Partner`
                  ].slice(0, 2)"
                  :key="item._id"
                >
                  <img
                    v-if="item.image == 'null'"
                    :src="caregiverPartner"
                    alt=""
                    class="profileimg"
                  />
                  <img
                    v-else
                    :src="$imageURL + '/' + item.image"
                    alt=""
                    class="profileimg"
                  />
                  <p class="fsize18">{{ item.name }}</p>
                </div>
                <div class="relative">
                  <div
                    class="flex gap-2 items-center p-2"
                    v-for="item in getDonorType.corporate[
                      `Caregiver's Champion Partner`
                    ].slice(2, 3)"
                    :key="item._id"
                  >
                    <img
                      v-if="item.image == 'null'"
                      :src="caregiverPartner"
                      alt=""
                      class="profileimg"
                    />
                    <img
                      v-else
                      :src="$imageURL + '/' + item.image"
                      alt=""
                      class="profileimg"
                    />
                    <p class="fsize18">{{ item.name }}</p>
                  </div>
                  <div class="absolute bottom-0 right-0">
                    <div
                      @click="
                        showDonorList(
                          'corporate',
                          `Caregiver's Champion Partner`,
                          caregiverPartner
                        )
                      "
                      class="cursor-pointer flex gap-2 items-center bg-primary custborderall p-2"
                    >
                      <p class="text-white fsize14">View All</p>
                      <feather-icon
                        icon="ArrowRightIcon"
                        svgClasses="w-4 h-4"
                        class="text-white"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      activeName: "first",
      isShowGratitude: false,
      listType: "",
      imgLink: "",
      caregiverChampion:
        "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/1%201.png",
      angelOfCare:
        "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/2%201.png",
      compassionSupport:
        "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/3%201.png",
      caregiverAdvocate:
        "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/6%201.png",
      caregiverPartner:
        "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/5%201.png",
      caregiverCompassion:
        "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/4%201.png",
    };
  },
  methods: {
    async getDonorList() {
      let loader;
      let payload = {
        category: "Donation Page",
        // type: this.filterType,
      };
      try {
        loader = this.$loading();
        let data = await this.$store.dispatch("services/donorType", payload);
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async showDonorList(type, plan, img) {
      let payload = {
        plan: plan,
        type: type,
        list: true,
        category: "Donation Page",
      };
      try {
        let data = await this.$store.dispatch("services/getDonor", payload);
        this.imgLink = img;
        this.listType = type;
        this.isShowGratitude = true;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    // this.showDonorList();
    this.getDonorList();
  },
  computed: {
    ...mapState("services", {
      getDonors: "getDonors",
      getDonorType: "getDonorType",
    }),
  },
};
</script>

<style>
.gratitudetab .el-tabs__nav {
  /* padding: 40px; */
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 100px;
}
.gratitudetab .el-tabs__nav-wrap {
  background: #f5efff;
  border-radius: 100px;
  width: fit-content !important;
  margin: auto;
}
.gratitudetab .el-tabs__item {
  color: #4f0a4b !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  border-radius: 30px;
  padding-top: 1;
  margin-top: 10px;
  margin-bottom: 10px;

  font-size: 18px;
}
.gratitudetab .el-tabs__item.is-active {
  background: #4f0a4b !important;
  color: white !important;
}
.gratitudetab .el-tabs__nav-wrap::after {
  height: 0px !important;
}
.gratitudetab .el-tabs__active-bar {
  height: 0px !important;
}
.custgratitudeimg {
  width: 100%;
  height: 230px;
  border-radius: 20px;
}
.profileimg {
  height: 34px;
  width: 34px;
  border-radius: 100px;
}
.custbordergr {
  border: 1px solid #fdaef8;
  border-radius: 20px;
}
.borderbott {
  border-bottom: 1px solid #efefef;
}
.custborderall {
  border-radius: 20px 0px 20px 0px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.view .el-dialog__body {
  padding: 0px !important;
}

.view .el-dialog__header {
  padding: 0px !important;
}
</style>
